export const getSharePreviewUrls = page => {
    const { socialSharePreview, twitterSharePreview } = page;

    return {
        social: socialSharePreview && socialSharePreview.url,
        twitter: twitterSharePreview && twitterSharePreview.url
    };
}
